<template>
  <div class="balance-block payout-balance-block">
    <div class="balance-block-wrapper">
      <div class="title small">PAYOUT BALANCE:</div>
      <div class="title amount">
        {{ roundedPayoutBalance }}
        <img src="../../images/coin.svg" class="currency-icon" alt="coin" />
      </div>
      <div class="button" @click="$emit('withdraw')">
        Withdraw
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfilePayoutBalanceBlock",
  props: {
    payoutBalance: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    roundedPayoutBalance() {
      return Math.floor((Number(this.payoutBalance) || 0) * 100) / 100;
    },
  },
};
</script>
